"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RheLogo = function RheLogo() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1440"
  }, _react.default.createElement("g", null, _react.default.createElement("rect", {
    width: "1440",
    height: "1440",
    fill: "none",
    opacity: "0"
  }), _react.default.createElement("rect", {
    width: "1440",
    height: "1440",
    fill: "#fff",
    opacity: "0"
  })), _react.default.createElement("g", {
    opacity: "0.25"
  }, _react.default.createElement("circle", {
    cx: "36",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "36",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "108",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "180",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "252",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "324",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "396",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "468",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "540",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "612",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "684",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "756",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "828",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "900",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "972",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "1044",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "1116",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "1188",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "1260",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "1332",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "36",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "180",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "252",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "324",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "396",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "468",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "540",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "612",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "684",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "756",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "828",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "900",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "972",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1044",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1116",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1188",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1260",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1332",
    cy: "1404",
    r: "18",
    fill: "#fff"
  }), _react.default.createElement("circle", {
    cx: "1404",
    cy: "1404",
    r: "18",
    fill: "#fff"
  })), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M612,738H468a90,90,0,0,0-90,90v216h0a18,18,0,0,0,36,0h0V828a54,54,0,0,1,54-54H612a54,54,0,0,1,54,54v72h0a18,18,0,0,0,36,0h0V828A90,90,0,0,0,612,738Z",
    fill: "#fff"
  }), _react.default.createElement("path", {
    d: "M972,738H828a89.6,89.6,0,0,0-54,18V612h0a18,18,0,0,0-36,0h0v432h0a18,18,0,0,0,36,0h0V828a54,54,0,0,1,54-54H972a54,54,0,0,1,54,54v216h0a18,18,0,0,0,36,0h0V828A90,90,0,0,0,972,738Z",
    fill: "#fff"
  }), _react.default.createElement("path", {
    d: "M1188,918h216a18,18,0,0,0,18-18V828a90,90,0,0,0-90-90H1188a90,90,0,0,0-90,90V972a90,90,0,0,0,90,90h216a18,18,0,0,0,0-36H1188a54,54,0,0,1-54-54V918Zm-54-90a54,54,0,0,1,54-54h144a54,54,0,0,1,54,54v54H1134Z",
    fill: "#fff"
  })));
};

var _default = RheLogo;
exports.default = _default;